/**
 * src/content/chartHelp.ts — "How to read this" microcopy (Appendix B), verbatim.
 */
export const CHART_HELP = {
  netWorth:
    'Your portfolio minus your loan. If this line rises, the strategy is building wealth despite the debt. Watch the gap between portfolio (top) and loan (bottom).',
  borrowVsSell:
    "Two ways to fund the same spending. If 'borrow' ends higher, keeping the loan beat selling — usually because your assets grew and you avoided capital-gains tax. If they cross, note when.",
  balance:
    'What you owe over time. With interest-only it rises only as you draw; if interest compounds, it curves upward on its own.',
  monthlyInterest: 'Your monthly borrowing cost. It rises with the balance and with the base rate.',
  cumulativeInterest:
    'Total interest paid so far — the running price of carrying the loan.',
  apr:
    "Your loan's rate over time, including the after-tax line if interest is deductible. Compare it to your expected return.",
  ltv:
    "Loan ÷ loan value of collateral. Closer to 100% = riskier. The danger zone and the 100% line show where a maintenance call hits. 'Cushion' is how big a market drop you could withstand before a call.",
  estate:
    "Value left to heirs under borrow vs sell. Borrowing can leave more because a step-up in basis may erase the lifetime gain — shown as 'income tax avoided.'",
  tornado: 'Which assumptions move the outcome most. The widest bars are what to get right.',
  monteCarlo:
    'Instead of one guess, this runs many random markets. The bands show the range of outcomes; the callout shows the chance of a maintenance call. Wider bands = more uncertainty.',
  stressTest:
    "This is a live 'what if the market dropped right now' check. As you drag, the gauge moves toward the red 100% line; when it crosses, you'd get a maintenance call. The tick on the slider is your breaking point — the drop you could withstand today. If it's small, you're fragile; if it's large, you have room.",
} as const;

export type ChartHelpKey = keyof typeof CHART_HELP;
